module.exports = __webpack_public_path__ + "static/media/IMG_1828.bed8af38.JPG";